import { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import UserPage from "../UserPage";
import { LoadingContext } from "../../../../contexts/Loading/LoadingContext";
import { api } from "../../../../services/api";
import "../styles.css";
import { Dashboard } from "../../../../contexts/Dashboard/DashboardContext";
import { AuthContext } from "../../../../contexts/Authentication/AuthContext";

const Pages = () => {
  const { changeVisibility } = useContext(LoadingContext);
  const { hasShortToken } = useContext(AuthContext);
  const { shortToken } = useParams();

  let route: string;
  const [pages, setPages] = useState<Dashboard[]>([]);
  const [completeRequisition, setCompleteRequisition] = useState(false);

  if (hasShortToken) {
    route = `/dashboards/configurations?short_token=${shortToken}`;
  } else {
    route = `/dashboards/configurations`;
  }

  useEffect(() => {
    changeVisibility(true);
    Promise.all([api.get(route)])
      .then(([response]: [{ data: Dashboard[] }]) => {
        if (response.data && response.data.length > 0) {
          setPages(response.data.reverse());
        }
      })
      .finally(() => {
        changeVisibility(false);
        setCompleteRequisition(true);
      });
  }, []);

  return (
    <>
      {completeRequisition ? (
        pages.map((page: Dashboard, index: number) => (
          <UserPage index={index} name={page.title} id={page.id ?? ''} />
        ))
      ) : (
        <></>
      )}
    </>
  );
};

export default Pages;
